import { api } from "@/lib/api";
import { isChompMuted } from "@/lib/chomp";
import { flipMath } from "@/lib/flip";
import { rareLabel } from "@/pages/RareAlert";

export const ATM_EVENT = "snaplist:atm";
const SEEN = "snaplist.atmSeen";
const seen = () => { try { return new Set(JSON.parse(localStorage.getItem(SEEN)) || []); } catch { return new Set(); } };

// Cash-register "cha-ching": two bright bells over a short coin rattle.
export function chaChing() {
  if (isChompMuted("rare")) return;
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    const t0 = ctx.currentTime;
    const bell = (f, at) => {
      const o = ctx.createOscillator(); const g = ctx.createGain();
      o.type = "triangle"; o.frequency.setValueAtTime(f, t0 + at);
      g.gain.setValueAtTime(0.0001, t0 + at); g.gain.exponentialRampToValueAtTime(0.18, t0 + at + 0.01); g.gain.exponentialRampToValueAtTime(0.0001, t0 + at + 0.5);
      o.connect(g).connect(ctx.destination); o.start(t0 + at); o.stop(t0 + at + 0.55);
    };
    [0, 0.06, 0.12, 0.18].forEach((at) => bell(2400 + Math.random() * 600, at));
    bell(1568, 0.3); bell(2093, 0.42);
    setTimeout(() => ctx.close(), 1500);
    navigator.vibrate?.([60, 40, 60, 40, 120]);
  } catch { /* no audio */ }
}

// Rare find whose asking / paid price hits the ROI target -> the ATM pays out (once per item + price).
export function atmIfRareHit({ key, title, rarity, price, ship = 0, target, buy, source = "", photoId = "" }) {
  if (!rareLabel(rarity) || buy === null || buy === undefined || buy === "" || !(Number(price) > 0)) return false;
  const m = flipMath(price, ship, target, Number(buy));
  if (!m.hits) return false;
  const id = `${key}|${Number(buy)}`;
  const s = seen();
  if (s.has(id)) return false;
  s.add(id);
  localStorage.setItem(SEEN, JSON.stringify([...s].slice(-300)));
  chaChing();
  api.post("/rare-finds/payouts", { key: id.slice(0, 200), source, title: (title || "").slice(0, 200), label: rareLabel(rarity).slice(0, 120),
    profit: Number(m.profit.toFixed(2)), roi: m.realRoi == null ? null : Math.round(m.realRoi), price: Number(price), buy: Number(buy), photo_id: photoId || "" }).catch(() => {});
  window.dispatchEvent(new CustomEvent(ATM_EVENT, { detail: { title: title || "", label: rareLabel(rarity), profit: m.profit, roi: m.realRoi } }));
  return true;
}
